import { render, staticRenderFns } from "./reuterspage.vue?vue&type=template&id=2cd4006d&"
import script from "./reuterspage.vue?vue&type=script&lang=js&"
export * from "./reuterspage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports